module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../node_modules/happypack/loader.js?id=jsx!./AlterAddressView.js"));
	}, "AlterAddressView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=AlterAddressView!./src/pages/Shop/Member/TradeManage/OrderList/AlterAddress/AlterAddressView.js
// module id = 1021
// module chunks = 438